module.exports = __webpack_public_path__ + "static/media/waybill-sea.97fafd13.webp";